import { render, staticRenderFns } from "./ListItemTopic.vue?vue&type=template&id=56224017&scoped=true&"
import script from "./ListItemTopic.vue?vue&type=script&lang=js&"
export * from "./ListItemTopic.vue?vue&type=script&lang=js&"
import style0 from "./ListItemTopic.vue?vue&type=style&index=0&id=56224017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56224017",
  null
  
)

export default component.exports